import { render } from "./SimuladosResults.vue?vue&type=template&id=03195d7f&scoped=true"
import script from "./SimuladosResults.vue?vue&type=script&lang=js"
export * from "./SimuladosResults.vue?vue&type=script&lang=js"

import "./SimuladosResults.vue?vue&type=style&index=0&id=03195d7f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03195d7f"]])

export default __exports__